import { render, staticRenderFns } from "./GenericFaqQuestions.vue?vue&type=template&id=67305573&scoped=true"
import script from "./GenericFaqQuestions.vue?vue&type=script&lang=js"
export * from "./GenericFaqQuestions.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqQuestions.vue?vue&type=style&index=0&id=67305573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67305573",
  null
  
)

export default component.exports